/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type HookTuple = [
  response: vp.WebhooksResponse,
  WebhooksHistory: (params: vp.WebhooksRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchWebhooks: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.WebhooksRequest>({
    EndDate: '',
    StartDate: '',
    Type: '',
  });

  const [response, setResponse] = useState<vp.WebhooksResponse>({
    Success: false,
    ErrorMessage: '',
    WebhookNotifications: { },
  });

  useEffect(() => {
    const sendRequest = async (requestParams: vp.WebhooksRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.fetchPartnerWebhooks(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.WebhooksRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        WebhookNotifications: { },
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchWebhooks);
